// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScrollMenu_wrapper__27xpP"};